<template>
  <b-card>
    <vue-apex-charts
      ref="pieChart"
      type="pie"
      height="350"
      :options="pieChart.chartOptions"
      :series="pieChart.series"
    />
  </b-card>
</template>

<script>
import { BCol, BRow, BCard, BCardTitle, BCardSubTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import chartColor from "./ChartColor";

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCol,
    BRow,
  },
  props: {
    issueName: {
      type: String,
      default: "",
    },
    titleText: {
      type: String,
      default: "",
    },
    filter: {
      type: Object,
      default: () => ({
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: userData.userId(),
        departmentId: userData.departmentId(),
      }),
    },
  },
  data() {
    return {
      chartColor,
      min: 1,
      max: 100,
      seriesCustomize: [], // apiDashboard
      labelsCustomize: [],
      pieChart: {
        series: [], // seriesCustomize
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          title: {
            text: this.titleText,
            align: "left",
            style: {
              fontSize: "18px",
            },
          },
          legend: {
            show: true,
            position: "right",
            width: "280",
          },
          colors: [
            // colors each series
          ],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "10px",
              colors: ["#000000"],
            },
            formatter(val) {
              // eslint-disable-next-line radix
              // return `${parseInt(val)}%`;
              return `${val.toFixed(2)}%`;
            },
          },
          plotOptions: {
            pie: {
              labels: {
                show: false,
                name: {
                  fontSize: "1rem",
                  // fontFamily: "Montserrat",
                },
                value: {
                  fontSize: "1rem",
                  // fontFamily: "Montserrat",
                  formatter(val) {
                    // eslint-disable-next-line radix
                    // return `${parseInt(val)}%`
                    return `${parseInt(val)}`;
                  },
                },
                total: {
                  show: false,
                  fontSize: "1.5rem",
                  label: "Operational",
                  formatter() {
                    return "31%";
                  },
                },
              },
            },
          },
          labels: [], // ได้จาก apiDashboard
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "right",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {},
              },
            },
          ],
          noData: {
            text: "ไม่พบข้อมูล",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "18px",
              fontFamily: undefined,
            },
          },
        },
      },
    };
  },
  mounted() {
    if (chartColor && chartColor.color) {
      this.max = chartColor.color.length;
    }

    // TEST
    // if (this.issueName === "ScreeningPieChartSummaryOverview") {
    //   console.log("ScreeningPieChartSummaryOverview Active");
    //   this.funcScreeningPieChartSummaryOverview(this.filter);
    // } else if (this.issueName === "AdminPieChartComplaintOverview"){
    //   console.log("AdminPieChartComplaintOverview Active");
    //   this.funcAdminPieChartComplaintOverview(this.filter);
    // }

    // if (this.issueName === "WEB_SERVICE") {
    //   this.funcGetWebService(this.filter);
    // } else if (this.issueName === "CONTINUE_TERMINATE_STATUS") {
    //   // this.funcGetContinueAndTerminateStatus(this.filter);
    // } else if (this.issueName === "RESULTS_THE_LEGAL_DEPARTMENT_INQUIRY") {
    //   this.funcGetResultsTheLegalDeptInquiry(this.filter);
    // } else if (this.issueName === "COMPLAINT_TO_OFFICER") {
    //   this.funcGetComplaintSendToOfficer(this.filter);
    // } else if (this.issueName === "TRACKING_COMPLAINT_STATUS") {
    //   this.funcGetTrackingComplaintStatus(this.filter);
    // } else if (this.issueName === "DOCUMENT_STATUS_OFFICER") {
    //   this.funcGetDocumentStatusForOfficer(this.filter);
    // } else if (this.issueName === "OUTSITE_DEPARTMENT") {
    //   this.funcGetComplaintSendToOutSiteDepartment(this.filter);
    // }
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    async getRandomChartColor(n) {
      const result = [];
      const colors = [...this.chartColor.color];

      while (result.length < n) {
        const shuffled = colors.sort(() => Math.random() - 0.5);
        const remaining = n - result.length;
        const takeCount = Math.min(remaining, shuffled.length);
        result.push(...shuffled.slice(0, takeCount));
      }

      this.pieChart.chartOptions.colors = [...result];
    },
    async funcScreeningPieChartSummaryOverview(obj) {
      console.log("funcScreeningPieChartSummaryOverview .filter", obj)

      apiDashboard
        .ScreeningPieChartSummaryOverview(obj)
        .then(async (response) => {
          console.log("funcScreeningPieChartSummaryOverview .response", response)
          console.log("funcScreeningPieChartSummaryOverview .response.data", response.data)

          this.seriesCustomize = response.data.data.map((value) => value.total);
          this.labelsCustomize = response.data.data.map(
            (value) => `${value.label} (${value.total})`
          );

          console.log("funcScreeningPieChartSummaryOverview .seriesCustomize", this.seriesCustomize)
          console.log("funcScreeningPieChartSummaryOverview .labelsCustomize", this.labelsCustomize)

          this.pieChart.series = this.seriesCustomize;
          // สีคงที่ตาม SortKey: 1 = อยู่ระหว่างคัดกรอง (ส้ม), 2 = ส่งออกจากกองแล้ว (เขียว)
          const screeningColors = { 1: "#FF9F43", 2: "#28C76F" };
          this.pieChart.chartOptions.colors = response.data.data.map(
            (value) => screeningColors[value.sortKey] ?? "#82868B"
          );

          this.pieChart.chartOptions.labels = this.labelsCustomize;
          this.updatePieChart();
        })
        .catch((error) => {
          console.log("funcScreeningPieChartSummaryOverview .error", error);
        });
    },
    async funcAdminPieChartComplaintOverview(obj) {
      console.log("funcAdminPieChartComplaintOverview .filter", obj)

      apiDashboard
        .AdminPieChartComplaintOverview(obj)
        .then(async (response) => {
          console.log("funcAdminPieChartComplaintOverview .response", response)
          console.log("funcAdminPieChartComplaintOverview .response.data", response.data)

          this.seriesCustomize = response.data.data.map((value) => value.total);
          this.labelsCustomize = response.data.data.map(
            (value) => `${value.label} (${value.total})`
          );

          console.log("funcAdminPieChartComplaintOverview .seriesCustomize", this.seriesCustomize)
          console.log("funcAdminPieChartComplaintOverview .labelsCustomize", this.labelsCustomize)

          this.pieChart.series = this.seriesCustomize;
          // สีคงที่ตาม SortKey: 1 = ค้างอยู่ในธุรการกอง (ส้ม), 2 = ส่งให้เจ้าหน้าที่แล้ว (ฟ้า)
          const adminColors = { 1: "#FF9F43", 2: "#00CFE8" };
          this.pieChart.chartOptions.colors = response.data.data.map(
            (value) => adminColors[value.sortKey] ?? "#82868B"
          );

          this.pieChart.chartOptions.labels = this.labelsCustomize;
          this.updatePieChart();
        })
        .catch((error) => {
          console.log("funcAdminPieChartComplaintOverview .error", error);
        });
    },
    updatePieChart() {
      // SP คืนแถวมาเสมอแม้ทุกค่าเป็น 0 แต่ ApexCharts จะวาดวงกลมว่างโดยไม่ขึ้น noData
      // จึงส่ง [] แทนเพื่อให้แสดง "ไม่พบข้อมูล"
      const sum = (this.pieChart.series || []).reduce((a, b) => a + (Number(b) || 0), 0);
      if (sum === 0) {
        this.pieChart.series = [];
      }

      // pie ต้องได้ series เป็น array ตัวเลขตรง ๆ ไม่ใช่ [{ data: [...] }]
      this.$refs["pieChart"].updateOptions({
        labels: this.pieChart.chartOptions.labels,
        colors: this.pieChart.chartOptions.colors,
      });
      this.$refs["pieChart"].updateSeries(this.pieChart.series);
    },
    myEventHandler(e) {
      this.$refs["pieChart"].refresh();
    },
  },
};
</script>